import { useQuery } from 'react-query';
import { wgApi } from '../../../../../app/src/features/api/wgApi';

interface Response {
  items: string[];
}

const getDocExtractionMimeTypes = async () => {
  const path = `v1/api/document-extractor/supported-mime-types`;
  const { data, isError } = await wgApi.get<Response>(path);
  if (isError) throw new Error('Error fetching document extraction mime types');
  return data;
};

export const getUseDocExtractionMimeTypesQKey = () => [
  'document-extraction',
  'mime-types',
];

export const useDocExtractionMimeTypes = () => {
  return useQuery(
    getUseDocExtractionMimeTypesQKey(),
    () => getDocExtractionMimeTypes(),
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      staleTime: Infinity,
    },
  );
};
